import {appRouter} from '@netx/core-next/instance/router';
import {type IBrandPortalAction} from '../schema';
import {getPortalPageSlugFromPortalAction} from './getPortalPageSlugFromPortalAction';

export const routeToPortalPageFromPortalAction = (
	portalAction: IBrandPortalAction,
) => {
	const slug = getPortalPageSlugFromPortalAction(portalAction);
	appRouter.navigate(`page/${slug}`, true);
};
